module.exports = __webpack_public_path__ + "static/img/10029.3e29c62b.png";